import {
  Mark,
  mergeAttributes,
} from '@tiptap/core'

import { mouseoverHandler } from './helpers/mouseoverHandler'

export interface InsertedOptions {
  /**
   * Whether the inserted text is disabled or not.
   * If true, the inserted text will not be clickable.
   * @default false
   */
  disabled?: boolean

  /**
   * Function to call when the inserted text is hovered.
   * It receives the suggestionId of the hovered element.
   */
  onMouseover?: (suggestionId: string, event: MouseEvent) => void
}

/**
 * This extension allows you to mark text as inserted.
 */
export const Inserted = Mark.create<InsertedOptions>({
  name: 'inserted',

  inclusive: false,

  addAttributes() {
    return {
      suggestionId: {
        default: '',
        parseHTML: (element) => {
          return element.getAttribute('data-suggestion-id')
        },
        renderHTML: (attributes) => ({
          'data-suggestion-id': attributes.suggestionId
        })
      },
      status: {
        default: 'pending',
        parseHTML: (element) => {
          return element.getAttribute('data-status')
        },
        renderHTML: (attributes) => ({
          'data-status': attributes.status
        })
      }
    }
  },

  addOptions() {
    return {
      onMouseover: (suggestionId: string) => { },
    }
  },

  parseHTML() {
    return [{ tag: 'ins' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['ins', mergeAttributes(HTMLAttributes), 0]
  },

  addProseMirrorPlugins() {
    return [
      mouseoverHandler({
        type: this.type,
        nodeName: 'INS',
        onMouseover: this.options.onMouseover,
      })
    ]
  },
})
